"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequest = void 0;
const ResponseError_1 = require("./ResponseError");
class BadRequest extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || BadRequest.label;
        this.type = BadRequest.type;
        this.statusCode = BadRequest.statusCode;
        Error.captureStackTrace(this, BadRequest);
    }
}
exports.BadRequest = BadRequest;
BadRequest.type = 'BadRequest';
BadRequest.label = 'Bad Request';
BadRequest.statusCode = 400;
//# sourceMappingURL=BadRequest.js.map